import { getSvg } from "../../components/icons/svg";
import React from "react";

export default function useDataTypeImgs() {
  const [imgs, setImgs] = React.useState<Record<string, HTMLImageElement>>({})

  const getLoadedImage = React.useCallback(async (key: string, svg_text: string) => {
    const image = new Image()
    image.src = "data:image/svg+xml;charset=utf-8," + getSvg(svg_text);
    image.onload = function () {
      setImgs((prev) => ({
        ...prev,
        [key]: image,
      }))
    }
    image.onerror = () => console.error(`Failed to load image at ${image.src}`)
  }, [])

  React.useEffect(() => {
    const types = [
      {key: "close_ended_text", svg: "Close_ended_text"},
      {key: "open_ended_text", svg: "Open_ended_text"},
      {key: "integer", svg: "int"},
      {key: "float", svg: 'float'},
      {key: "alphanumeric", svg: 'Alphanumeric'},
      {key: 'date & time', svg: "datetime"}
    ]
    getLoadedImage('DOMAIN', 'domain')
    getLoadedImage('TABLE', 'table')
    types.forEach(type => getLoadedImage(type.key, type.svg))
  }, [getLoadedImage])


  return {imgs}
}
